import { render, staticRenderFns } from "./MoreMenuMoney.vue?vue&type=template&id=cdffb56e&scoped=true&"
import script from "./MoreMenuMoney.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuMoney.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuMoney.vue?vue&type=style&index=0&id=cdffb56e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdffb56e",
  null
  
)

export default component.exports